"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validatorJS = require("validator");
class IsUppercaseValidator {
    isValid(input) {
        if (typeof input === "undefined" || input === null) {
            return false;
        }
        return validatorJS.isUppercase(input);
    }
}
exports.IsUppercaseValidator = IsUppercaseValidator;
//# sourceMappingURL=IsUppercaseValidator.js.map